import { useState } from 'react'

import { previewSections } from '@/configuration/pages/ConfigurationPage/ThemeConfiguration/constants'

const usePreviewSection = ({ trackingPreviewUrl, returnsPortalUrl }) => {
  const [activePreviewSection, setActivePreviewSection] = useState(previewSections.returnsPortal)

  const handlePreviewSection = section => {
    setActivePreviewSection(section)
  }

  const previewUrl = activePreviewSection === previewSections.trackingPage ? trackingPreviewUrl : returnsPortalUrl

  return {
    activePreviewSection,
    handlePreviewSection,
    previewUrl,
  }
}

export default usePreviewSection
